import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noRowsFound: {
    defaultMessage: 'No Rows Were Found',
    description: 'No rows were found message display on table'
  },
  defaultTitleInExportAsPdfPage: {
    defaultMessage: 'Report',
    description: 'Default title in export as pdf page'
  },
  filterChipLoader: {
    defaultMessage: 'Loading...',
    description: 'Loading message when filter chip selected'
  },
  exportInvoicesError: {
    defaultMessage:
      'Unable to export more than 15,000 invoices. Please adjust the filters and try again.',
    description:
      'Error message for when user tries to export/archive more than 15k invoices'
  },
  printInvoicesError: {
    defaultMessage:
      'Unable to print more than 15,000 invoices. Please adjust the filters and try again.',
    description:
      'Error message for when user tries to print more than 15k invoices'
  }
});
